import {graphql} from 'gatsby'
import React, {useEffect, useState} from 'react'
import ColumnBackAndForth from '../../../components/atoms/columnBackAndForth'
import SEO from '../../../components/atoms/seo'
import {ITopicPath} from '../../../components/atoms/topicPath'
import ColumnDetailInner0063 from '../../../components/molecules/columnDetailInner0063'
import ColumnDetailsBody from '../../../components/organisms/columnDetailsBody'
import ColumnLayout from '../../../components/organisms/columnLayout'
import Conclusion001 from '../../../components/molecules/Conclusion001'
import Conclusion002 from '../../../components/molecules/Conclusion002'
import Conclusion003 from '../../../components/molecules/Conclusion003'
import Conclusion004 from '../../../components/molecules/Conclusion004'
import Conclusion005 from '../../../components/molecules/Conclusion005'
import Conclusion006 from '../../../components/molecules/Conclusion006'
import Conclusion007 from '../../../components/molecules/Conclusion007'
import Conclusion008 from '../../../components/molecules/Conclusion008'
import Conclusion009 from '../../../components/molecules/Conclusion009'
import ColumnAuthor001 from '../../../components/molecules/columnAuthor001'
import CarouselBanner from '../../../components/molecules/carouselBanner'
import PopupBanner from '../../../components/molecules/popupBanner'
import UsefulFunctionLayout015 from '../../../components/molecules/usefulFunctionLayout015'

/**
 * コラム記事詳細画面
 * @constructor
 */
const C0063 = () => {
  const paths: ITopicPath[] = [
    { title: 'キンクラコラムTOP', link: '/column' },
    { title: 'コラム記事一覧', link: '/column/list' },
    {
      title:
        '勤怠管理と給与計算の連携について。なぜ連携した方がいいの？留意すべきポイントとは',
    },
  ]

  // 0~8ランダム数字を保存
  const [no, setNo] = useState(-1)
  useEffect(() => {
    setNo(Math.floor(Math.random() * 9))
  }, [])

  return (
    <ColumnLayout paths={paths}>
      <SEO
        title="勤怠管理と給与計算の連携について。なぜ連携した方がいいの？留意すべきポイントとは"
        description="勤怠管理と給与計算は相互に連携することで相互の事務の簡素化合理化を進めることが可能です。留意すべきポイントなどについて解説します。"
        ogUrl="https://kintaicloud.jp/column/details/C0063/"
        ogType="article"
        ogTitle="勤怠管理と給与計算の連携について。なぜ連携した方がいいの？留意すべきポイントとは"
        ogDescription="勤怠管理と給与計算は相互に連携することで相互の事務の簡素化合理化を進めることが可能です。留意すべきポイントなどについて解説します。"
        ogSiteName="キンクラ - 客先常駐特化型のクラウド勤怠管理システム"
        ogImage="https://www.kintaicloud.jp/images/column/details/c0063.jpg"
      />
      <ColumnDetailsBody>
        {/** ポップアップバナー */}
        <PopupBanner />
        {/** 記事本体 */}
        <ColumnDetailInner0063 no={no} />

        {/** ここに9パターンの広告設定する */}
        {no === 0 && <Conclusion001 />}
        {no === 1 && <Conclusion002 />}
        {no === 2 && <Conclusion003 />}
        {no === 3 && <Conclusion004 />}
        {no === 4 && <Conclusion005 />}
        {no === 5 && <Conclusion006 />}
        {no === 6 && <Conclusion007 />}
        {no === 7 && <Conclusion008 />}
        {no === 8 && <Conclusion009 />}

        {/** オーサ情報 */}
        <ColumnAuthor001 />
        {/** お役立ち機能 */}
        <UsefulFunctionLayout015 />
        {/** 前後記事への遷移 */}
        <ColumnBackAndForth />
        {/** カルーセルバナー */}
        <CarouselBanner />
        {/** 関連記事 */}
        {/* <ColumnRelationCards0063 /> */}
      </ColumnDetailsBody>
    </ColumnLayout>
  )
}

export default C0063

export const pageQuery = graphql`
  query C0063 {
    site {
      siteMetadata {
        title
      }
    }
  }
`
